import Hero from "@/components/Hero";
import BrandLogos from "@/components/BrandLogos";
import Services from "@/components/Services";
import ProblemsAndSolutions from "@/components/ProblemsAndSolutions";
import TraditionalProductions from "@/components/TraditionalProductions";
import AIProductions from "@/components/AIProductions";
import VideoTestimonials from "@/components/VideoTestimonials";
import ClientFeedbacks from "@/components/ClientFeedbacks";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Philosophy from "@/components/Philosophy";
import WebseitenShowcase from "@/components/WebseitenShowcase";
import SEO from "@/components/SEO";

const Index = () => {
  return (
    <main className="min-h-screen">
      <SEO
        title="Ihre Experten für Videoproduktionen aus Aachen – Aivinity"
        description="Aivinity (ehemals JC Productions) produziert strategische Imagefilme, Recruiting-Videos und Kampagnen für Unternehmen in Aachen & NRW."
        canonical="/"
      />
      <Hero />
      <BrandLogos />
      <Philosophy />
      <Services />
      <ProblemsAndSolutions />
      <TraditionalProductions />
      <AIProductions />
      <WebseitenShowcase />
      <VideoTestimonials />
      <ClientFeedbacks />
      {/* Rebranding Section for SEO */}
      <section className="py-12 md:py-16 border-t border-border/30">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl text-center">
          <h2 className="text-xl md:text-2xl font-halenoir font-normal tracking-tight mb-3 text-foreground/80">
            Aivinity – ehemals JC Productions
          </h2>
          <p className="text-sm md:text-base text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Aivinity ist die Weiterentwicklung von JC Productions. Unter neuem Namen verbinden wir strategische Konzeption mit moderner Videoproduktion in Kinoqualität.
          </p>
        </div>
      </section>
      <Contact />
      <Footer />
    </main>
  );
};

export default Index;
